// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"64085cd1","126":"fbc8b178","366":"ebcd9286","372":"d2fb799e","530":"1c11099b","612":"862d46be","782":"36cdb85b","886":"568978ce"}[chunkId] + ".chunk.js";
};